import type { ReactNode } from 'react'
import css from './DropdownItem.module.css'
import {TextMidd, TextSmall} from "../../../Text";
import TextMiddBold from "@/components/ui/Text/TextMiddBold.tsx";

interface DropdownItemProps {
    icon?: ReactNode
    title?: string
    rightTitle?: string
    rightIcon?: ReactNode
    onClick?: () => void
    disabled?: boolean
    muted?: boolean
    danger?: boolean
    highlight?: boolean
    testId?: string
}

const DropdownItem = ({ icon, title, rightTitle, rightIcon, onClick, disabled = false, muted = false, danger = false, highlight = false, testId }: DropdownItemProps) => {
    const className = [
        css.item,
        disabled && css.disabled,
        muted && css.muted,
        danger && css.danger,
        highlight && css.highlight,
        (!disabled && onClick) && css.clickable
    ].filter(Boolean).join(' ')

    const handleClick = () => {
        if (!disabled && onClick) {
            onClick()
        }
    }

    const TitleText = highlight ? TextMiddBold : TextMidd;

    return (
        <div className={className} onClick={handleClick} data-testid={testId}>
            <div className={css.left}>
                {icon && <span className={css.icon}>{icon}</span>}
                {title && <span className={css.title} title={title}>
                    <TitleText>{title}</TitleText>
                </span>}
            </div>
            {(rightTitle || rightIcon) && (
                <div className={css.right}>
                    {rightTitle && <span className={css.right_title}><TextSmall>{rightTitle}</TextSmall></span>}
                    {rightIcon && <span className={css.right_icon}>{rightIcon}</span>}
                </div>
            )}
        </div>
    )
}

export default DropdownItem
